/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-14T20:19:04.278
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listManagementAreaUser,
	listManagementAreaUserInit,
	listManagementAreaUserByAuthorizations,
	deleteManagementAreaUser,
	saveOrgusermanageToAreaUser
	
} from '@api/storagemanage/ManagementAreaUser';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listManagementAreaUser({
			state
		}) {
			return new Promise((resolve, reject) => {
				listManagementAreaUser(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listManagementAreaUserByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listManagementAreaUserByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listManagementAreaUserInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listManagementAreaUserInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteManagementAreaUser({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteManagementAreaUser({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		saveOrgusermanageToAreaUser({}, ManagementAreaUser) {
			return new Promise((resolve, reject) => {
				saveOrgusermanageToAreaUser(ManagementAreaUser)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
